import { declareStorageDomain } from '../../storage/storageGate';

const KEY_PREFIX = 'ximi_usage_reported_day.';
const keyFor = (ssoSub: string): string => `${KEY_PREFIX}${ssoSub}`;

/**
 * Last day (local `YYYY-MM-DD`) the Stimul'In usage was declared to Ozmo, per SSO account —
 * two accounts on the same device each declare their own usage.
 */
const storage = declareStorageDomain({
    name: 'ximi-usage',
    // Optional by contract; purged so a device handed over declares the next account's usage.
    onLogout: async (s) => {
        const keys = (await s.getKeys()).filter((key) => key.startsWith(KEY_PREFIX));
        await Promise.all(keys.map((key) => s.remove(key)));
    },
    // Accompanied mode keeps the Pro's SSO session: their declaration stays valid.
    onIdentitySwitch: async () => {}
});

export const getXimiUsageReportedDay = (ssoSub: string): Promise<string | null> =>
    storage.getString(keyFor(ssoSub));

export const setXimiUsageReportedDay = (ssoSub: string, day: string): Promise<void> =>
    storage.setString(keyFor(ssoSub), day);
